module.exports = __webpack_public_path__ + "95be30db278fa12f58d34ff24542a071.pdf";